import DatePicker from 'components/form/DatePicker';
import TextInput from 'components/form/TextInput';
import React from 'react';
// Coupon or Voucher follow ups/early bird deadline
const SecondStepOfFollowUps = ({ props, isEdit, suggestionData }) => {
  // const { handleChange, values } = props;
  const { values, errors, touched, handleChange, handleBlur } = props;

  const {
    client_name,
    conference_short_name,
    conference_from_date,
    conference_to_date,
    conference_location,
    coupon_code,
    registration_link,
    your_name,
    contact_details,
  } = values;
  return (
    <>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Recipient's Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="client_name"
            onChange={handleChange}
            value={client_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.client_name && errors.client_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference Short Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="conference_short_name"
            onChange={handleChange}
            value={conference_short_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={
              touched.conference_short_name && errors.conference_short_name
            }
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference From Date
        </div>
        <div className="col-lg-6">
          <DatePicker
            id="conference_from_date"
            onChange={handleChange}
            value={conference_from_date}
            disabled={!isEdit}
            // onBlur={handleBlur}
            error={errors.conference_from_date}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference To Date
        </div>
        <div className="col-lg-6">
          <DatePicker
            id="conference_to_date"
            onChange={handleChange}
            value={conference_to_date}
            disabled={!isEdit}
            // onBlur={handleBlur}
            error={errors.conference_to_date}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference Venue
        </div>
        <div className="col-lg-6">
          <TextInput
            id="conference_location"
            onChange={handleChange}
            value={conference_location}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.conference_location && errors.conference_location}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Coupon Code
        </div>
        <div className="col-lg-6">
          <TextInput
            id="coupon_code"
            onChange={handleChange}
            value={coupon_code}
            disabled={!isEdit}
            suggestions={suggestionData?.coupon_code}
            onBlur={handleBlur}
            error={touched.coupon_code && errors.coupon_code}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Register Link
        </div>
        <div className="col-lg-6">
          <TextInput
            id="registration_link"
            onChange={handleChange}
            value={registration_link}
            disabled={!isEdit}
            suggestions={suggestionData?.registration_link}
            onBlur={handleBlur}
            error={touched.registration_link && errors.registration_link}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Your Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="your_name"
            onChange={handleChange}
            value={your_name}
            disabled={!isEdit}
            suggestions={suggestionData?.your_name}
            onBlur={handleBlur}
            error={touched.your_name && errors.your_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Contact Details
        </div>
        <div className="col-lg-6">
          <TextInput
            id="contact_details"
            onChange={handleChange}
            value={contact_details}
            disabled={!isEdit}
            suggestions={suggestionData?.contact_details}
            onBlur={handleBlur}
            error={touched.contact_details && errors.contact_details}
          />
        </div>
      </div>

      {/* <div className="d-flex align-items-center flex-wrap cmb-20">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Support Email
        </div>
        <div className="col-lg-6">
          <TextInput
            id="support_email"
            onChange={handleChange}
            value={support_email}
          />
        </div>
      </div> */}

      {/* <div className="d-flex align-items-center flex-wrap cmb-20">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Your Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="your_name"
            onChange={handleChange}
            value={your_name}
            disabled={!isEdit}
          />
        </div>
      </div> */}
      {/* <div className="d-flex align-items-center flex-wrap cmb-20">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Your Title
        </div>
        <div className="col-lg-6">
          <TextInput
            id="your_title"
            onChange={handleChange}
            value={your_title}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-20">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Your Contact Information
        </div>
        <div className="col-lg-6">
          <TextInput
            id="your_contact_information"
            onChange={handleChange}
            value={your_contact_information}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-20">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Your Website
        </div>
        <div className="col-lg-6">
          <TextInput
            id="your_website"
            onChange={handleChange}
            value={your_website}
          />
        </div>
      </div> */}
    </>
  );
};

export default SecondStepOfFollowUps;
